import React from 'react';
import {Flex, SVGButton} from '/app/src/component'
import {history} from '/app/src/store/store'
import {AdminComponent} from '/app/src/hoc'



export default function ()  {

    const AdminSettingButton = AdminComponent(SVGButton)
     return(
      <Flex height='40px' shrink={0} backgroundColor='mediumgrey' px='5px'>
          <SVGButton src='/images/SwitchSystem_M.svg' text='Kanaler' fontSize='20px' fontWeight='500' cursor='default'/>
          <AdminSettingButton src='/images/Settings_M.svg' marginLeft='auto' hover='blue' onClick={()=>{history.push('/clientChat/exchange')}}/>
      </Flex>
      )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/LeftPanel/ExchangeNotification/_header.js